import React, { type FormEvent, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FireDepartmentService } from '../../../../services';
import { SimpleBox } from '../../../atoms';

export function AddDepartment(): React.JSX.Element {
  const [name, setName] = useState('');

  const handleAddDepartment = async (): Promise<void> => {
    const addFirefighterResponse = await FireDepartmentService.addFireDepartment(name);
    if (addFirefighterResponse.error) {
      toast.error('Fehler beim Erstellen der neuen Abteilung 😩');

      return;
    }

    setName('');
    toast.success('Abteilung hinzugefügt ✅');
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
  };

  const handleKeyPress = (key: string): void => {
    if (key === 'Enter') {
      handleAddDepartment();
    }
  };

  return (
    <div className='container mt-10'>
      <div className='row'>
        <div className='col-12'>
          <SimpleBox>
            <h4>Abteilung hinzufügen</h4>
            <Form onSubmit={handleSubmit}>
              <Form.Group className='mt-4 mb-3' controlId='formGroupName'>
                <div className='row'>
                  <div className='col-12'>
                    <Form.Control
                      type='text'
                      placeholder='Abteilungsname'
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      onKeyDown={(e) => handleKeyPress(e.key)}
                    ></Form.Control>
                  </div>
                </div>
              </Form.Group>

              <Form.Group controlId='formGroupAdd'>
                <div className='row'>
                  <div className='col-12'>
                    <Button onClick={() => handleAddDepartment()}>Hinzufügen</Button>
                  </div>
                </div>
              </Form.Group>
            </Form>
          </SimpleBox>
        </div>
      </div>
    </div>
  );
}
